import GlobalTextInputField from "@components/inputs/GlobalTextInputField";
import { useState } from "react";

const OpenBankingConfig = () => {
  const [payInBps, setPayInBps] = useState<number>(0);
  const [payOutBps, setPayOutBps] = useState<number>(0);
  const [minPayInFees, setMinPayInFees] = useState<number>(0);
  const [minPayOutFees, setMinPayOutFees] = useState<number>(0);
  return (
    <div className="flex flex-col bg-bg-base p-[12px] gap-[16px]">
      {/* Fees */}
      <div className="flex flex-col">
        <span className="text-[12px] font-semibold pb-[8px]">FEES</span>
        <div className="rounded-[8px] border border-border-subtle bg-bg-page-body">
          <div className="flex flex-row p-[8px] border-b border-b-border-subtle">
            <span className="font-semibold text-[10px] w-[40%]">
              Description
            </span>
            <span className="font-semibold text-[10px] w-[30%]">PayIn</span>
            <span className="font-semibold text-[10px] w-[30%]">PayOut</span>
          </div>
          <div className="flex flex-row px-[8px] py-[4px] items-center border-b border-b-border-subtle">
            <span className="font-normal text-[10px] w-[40%]">Bps</span>
            <div className="w-[30%] mr-[8px]">
              <GlobalTextInputField
                type="number"
                value={payInBps.toString()}
                onChange={(e) => {
                  setPayInBps(Number(e.target.value));
                }}
                placeholder="Set new rate"
              />
            </div>
            <div className="w-[30%]">
              <GlobalTextInputField
                type="number"
                value={payOutBps.toString()}
                onChange={(e) => {
                  setPayOutBps(Number(e.target.value));
                }}
                placeholder="Set new rate"
              />
            </div>
          </div>
          <div className="flex flex-row px-[8px] py-[4px] justify-between items-center">
            <span className="font-normal text-[10px] w-[40%]">
              Min Fees Fixed
            </span>
            <div className="w-[30%] mr-[8px]">
              <GlobalTextInputField
                type="number"
                value={minPayInFees.toString()}
                onChange={(e) => {
                  setMinPayInFees(Number(e.target.value));
                }}
                placeholder="Set new rate"
              />
            </div>
            <div className="w-[30%]">
              <GlobalTextInputField
                type="number"
                value={minPayOutFees.toString()}
                onChange={(e) => {
                  setMinPayOutFees(Number(e.target.value));
                }}
                placeholder="Set new rate"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OpenBankingConfig;
